module.exports = __webpack_public_path__ + "static/img/open1.c0ebe9b4.png";